/**
 * Textos exibidos no alerta que direciona o usuário para acessar a versão
 * completa da carteira.
 */
export const WALLET_FULL_ACCESS_ALERT_TEXT_DEFAULT =
  'Acesse a versão completa da sua carteira no aplicativo Santander Corretora.';

export const WALLET_FULL_ACCESS_ALERT_TEXT_SANTANDER =
  'O valor da carteira corresponde ao saldo investido na Corretora. Para visualizar os valores investidos no Banco Santander, acesse a versão completa em nosso aplicativo.';

export const WALLET_FULL_ACCESS_ALERT_LINK_LABEL = 'Saiba mais';